import dayjs from 'dayjs';
import { CALENDLY_ONBOARDING_CALL_URL } from '@/constants/global';

function getCalendlyOnboardingCallUrl() {
  const formattedDate = dayjs().format('YYYY-MM');
  return `${CALENDLY_ONBOARDING_CALL_URL}?month=${formattedDate}`;
}


export default getCalendlyOnboardingCallUrl;
